import { defineStore } from 'pinia'
import { catalogService } from '@/services/catalogService'

export const useCategoryStore = defineStore('category', {
  state: () => ({
    categories: [],
    isLoading: false,
    error: null,
    currentCategory: null
  }),

  getters: {
    mainCategories: (state) => state.categories.filter(c => c.parentCategoryId === null),
    
    getChildCategories: (state) => (parentId) => {
      return state.categories.filter(c => c.parentCategoryId === parentId)
    },

    getCategoryBySlug: (state) => (slug) => {
      // Accetta gli slug sia con sia senza slash iniziale.
      const cleanSlug = String(slug || '').replace(/^\//, '')
      return state.categories.find(c => String(c.slug || '').replace(/^\//, '') === cleanSlug)
    }
  },

  actions: {
    async fetchCategories(lang = 'it') {
      this.isLoading = true
      this.error = null
      try {
        const response = await catalogService.getCategories(lang)
        const categories = response.data || []
        // Ordina le categorie per displayOrder (crescente)
        this.categories = categories.sort((a, b) => a.displayOrder - b.displayOrder)
      } catch (err) {
        console.error('[CategoryStore] Error fetching categories:', err)
        this.error = 'Errore nel caricamento delle categorie.'
      } finally {
        this.isLoading = false
      }
    },

    setCurrentCategory(category) {
      this.currentCategory = category
      if (category) {
        this.updateSEO(category)
      }
    },

    updateSEO(category) {
      if (!category) return

      // Update Page Title
      if (category.seoTitle) {
        document.title = category.seoTitle
      }

      // Update Meta Description
      const metaDescription = document.querySelector('meta[name="description"]')
      if (metaDescription && category.seoDescription) {
        metaDescription.setAttribute('content', category.seoDescription)
      }
    }
  }
})
